import React from 'react';

interface StepProps {
  recordId: string; // The record ID passed to the component
  handleClose: () => void; // Function to close the popup
  onUpdate: (updatedRecord: any) => void; // Function to handle updates
}

const ConnectionTypePopup: React.FC<StepProps> = ({ recordId, handleClose, onUpdate }) => {
  const [selectedTypes, setSelectedTypes] = React.useState<string[]>([]);

  const connectionOptions = [
    { label: 'Residential/Cellular (ISP)', value: 'ISP', tooltip: 'The standard type of connection when browsing from home or a mobile phone.' },
    { label: 'Commercial/Business (COM)', value: 'COM', tooltip: 'Traffic originating from commercial or business networks.' },
    { label: 'Safe Local Residential VPN (RES)', value: 'RES', tooltip: 'Safe residential VPNs with local connections.' },
    { label: 'Organization (ORG)', value: 'ORG', tooltip: 'Traffic from organizational IPs.' },
    { label: 'Government (GOV)', value: 'GOV', tooltip: 'Traffic from government-related networks.' },
    { label: 'Military (MIL)', value: 'MIL', tooltip: 'Traffic from military networks.' },
    { label: 'University/College/School (EDU)', value: 'EDU', tooltip: 'Traffic originating from educational institutions.' },
    { label: 'Library (LIB)', value: 'LIB', tooltip: 'Traffic originating from public or private libraries.' },
  ];

  const handleCheckboxChange = (value: string) => {
    setSelectedTypes((prev) =>
      prev.includes(value) ? prev.filter((type) => type !== value) : [...prev, value]
    );
  };

  const handleSave = () => {
    const updatedRecord = {
      recordId,
      selectedConnectionTypes: selectedTypes,
    };
    onUpdate(updatedRecord);
    handleClose();
  };

  return (
    <div className="popup-container">
      <div className="popup-header">
        <h2>Campaign: Connection Type</h2>
      </div>
      <div className="popup-content">
        <p>
          Connection type allows you to filter the traffic based on the originating IP service provider. For example, you could check "EDU" if you only wish to target users that browse from universities, colleges, or other educational units.
        </p>
        <p>
          The most common connection type is the Residential/Cellular (ISP) connection, which is the standard type of connection when browsing from home or a mobile phone.
        </p>
        <div className="connection-options" style={{fontSize:'12px'}}>
          {connectionOptions.map((option) => (
            <div key={option.value} className="connection-option">
              <label >
                <input
                style={{marginTop:"3px"}}
                  type="checkbox"
                  checked={selectedTypes.includes(option.value)}
                  onChange={() => handleCheckboxChange(option.value)}
                />
                {option.label}
                {/* <span className="tooltip">{option.tooltip}</span> */}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="popup-actions" style={{textAlign:'center'}}>
        {/* <button onClick={handleClose} className="btn-cancel">
          Cancel
        </button> */}
        <button style={{padding:'3px 40px', backgroundColor:'#1173B7', color:"white", fontSize:'11px', borderColor:'transparent'}} onClick={handleSave} className="btn-save" disabled={selectedTypes.length === 0}>
          Update
        </button>
      </div>
    </div>
  );
};

export default ConnectionTypePopup;
